module.exports = __webpack_public_path__ + "img/pic41.e1650b72.png";